import clsx from "clsx";
import { useLayoutEffect } from "react";
import { useWatch } from "react-hook-form";
import { GenericAsyncMultiSelect, GenericAsyncMultiSelectProps } from "components/Form/Select/GenericAsyncMultiSelect";
import { useFloatingField } from "./context";
import { sizeStyles } from "./sizeStyles";

function FloatingAsyncMultiSelect<T>({ control, name, chakraStyles, ...rest }: GenericAsyncMultiSelectProps<T>) {
  const { setHasValue, hasValue, size } = useFloatingField();
  const styles = sizeStyles[size];
  const value = useWatch({ control, name });

  useLayoutEffect(() => {
    const arr = Array.isArray(value) ? value : value ? [value] : [];
    setHasValue(arr.length > 0);
  }, [value, setHasValue]);

  return (
    <div className={clsx("floating-multi-select", hasValue && "chakra-react-select--has-value")}>
      <GenericAsyncMultiSelect<T>
        {...rest}
        control={control}
        name={name}
        chakraStyles={{
          control: (provided: any) => ({
            ...provided,
            backgroundColor: "transparent",
            boxShadow: "none",
          }),
          multiValue: (provided: any) => ({
            ...provided,
            minHeight: styles.multiValueMinHeight,
            bg: "cdsIndigo.50",
            _dark: { bg: "cdsIndigo.900" },
          }),
          multiValueLabel: (provided: any) => ({
            ...provided,
            paddingTop: styles.multiValueLabelPaddingOverride ?? provided.paddingTop,
            paddingBottom: styles.multiValueLabelPaddingOverride ?? provided.paddingBottom,
            color: "cdsIndigo.500",
          }),
          multiValueRemove: (provided: any) => ({
            ...provided,
            color: "cdsIndigo.500",
            _hover: { bg: "cdsIndigo.100", color: "cdsIndigo.700", _dark: { bg: "cdsIndigo.800" } },
          }),
          ...chakraStyles,
        }}
      />
    </div>
  );
}

export default FloatingAsyncMultiSelect;
